import { render } from "./Reports.vue?vue&type=template&id=7cc5b855"
const script = {}

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Partials/Reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cc5b855"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cc5b855', __exports__)) {
    console.log('reload')
    api.reload('7cc5b855', __exports__)
  }
  
  module.hot.accept("./Reports.vue?vue&type=template&id=7cc5b855", () => {
    console.log('re-render')
    api.rerender('7cc5b855', render)
  })

}


export default __exports__